import { Injectable } from '@angular/core';
import { initializeApp } from 'firebase/app';
import { getRemoteConfig, fetchAndActivate, getString, getBoolean, RemoteConfig } from 'firebase/remote-config';
import { environment } from 'environments/environment';
import { Motd } from 'app/models/motd';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  private remoteConfig: RemoteConfig;

  constructor() {
    const app: any = initializeApp({
      apiKey: 'AIzaSyBnbH8DATDeZgqEEHlx3Nq9a-MiT2KmOTE',
      authDomain: 'toteim-e807f.firebaseapp.com',
      projectId: 'toteim-e807f',
      storageBucket: 'toteim-e807f.firebasestorage.app',
      messagingSenderId: '136091351855',
      appId: '1:136091351855:web:c8a298fa5e94e944e83fda'
    });

    this.remoteConfig = getRemoteConfig(app);

    this.remoteConfig.settings = {
      minimumFetchIntervalMillis: 30000,
      fetchTimeoutMillis: 60000
    };

    this.remoteConfig.defaultConfig = {
      [`maintenance_${environment.env_name}`]: 'false',
      ['maintenance_message']: JSON.stringify({
        fr: 'Maintenance en cours.',
        en: 'Maintenance in progress.'
      }),
      [`motd_${environment.env_name}`]: 'false',
      [`motd_msg_${environment.env_name}`]: '{}'
    };
  }

  async isMaintenanceMode(): Promise<boolean> {
    try {
      await fetchAndActivate(this.remoteConfig);

      return getBoolean(this.remoteConfig, `maintenance_${environment.env_name}`);
    } catch (_) {
      return false;
    }
  }

  async getMaintenanceMessage(lang: string): Promise<string | null> {
    try {
      await fetchAndActivate(this.remoteConfig);

      const messages: any = JSON.parse(getString(this.remoteConfig, 'maintenance_message'));

      return messages[lang] || messages['fr'] || null;
    } catch (_) {
      return null;
    }
  }

  async getMotdMessages(): Promise<Record<string, Motd> | null> {
    try {
      await fetchAndActivate(this.remoteConfig);

      if (!getBoolean(this.remoteConfig, `motd_${environment.env_name}`)) {
        return null;
      }

      return JSON.parse(getString(this.remoteConfig, `motd_msg_${environment.env_name}`));
    } catch (_) {
      return null;
    }
  }

}
